export default [
    {
        path: '/teamWork',
        component: () => import('../components/pages/teamWork/TeamWork.vue') ,
        meta: {
            title: '加盟合作'
        }
    }

]